import _ from 'lodash';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import types from 'frontend/state/actionTypes';

const stateVersion = () => 21;

function versionReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_STATUS_SUCCESS:
      return _.get(payload, 'version.version', null);
    default:
      return state;
  }
}

function versionUpdatedReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_STATUS_SUCCESS:
      return _.get(payload, 'version.updated', null);
    default:
      return state;
  }
}

function initialVersionReducer(state = null) {
  return state;
}
function initialVersionUpdatedReducer(state = null) {
  return state;
}

export default combineReducers({
  stateVersion,
  version: versionReducer,
  versionUpdated: versionUpdatedReducer,
  initialVersion: initialVersionReducer,
  initialVersionUpdated: initialVersionUpdatedReducer,
});

const baseSelector = state => state.version;
const stateVersionSelector = state => baseSelector(state).stateVersion;
const initialVersionSelector = state => baseSelector(state).initialVersion;
const initialVersionUpdatedSelector = state => baseSelector(state).initialVersionUpdated;
const versionSelector = state => baseSelector(state).version;
const versionUpdatedSelector = state => baseSelector(state).versionUpdated;
const newVersionAvailableSelector = createSelector(
  versionSelector,
  versionUpdatedSelector,
  initialVersionSelector,
  initialVersionUpdatedSelector,
  (version, versionUpdated, initialVersion, initialVersionUpdated) => {
    if (initialVersion && version && version !== initialVersion) {
      const initialTime = new Date(initialVersionUpdated).getTime();
      const currentTime = new Date(versionUpdated).getTime();
      return currentTime > initialTime;
    }
    return false;
  },
);

export const selectors = {
  version: versionSelector,
  stateVersion: stateVersionSelector,
  initialVersion: initialVersionSelector,
  newVersionAvailable: newVersionAvailableSelector,
};
